import { createClient } from '@supabase/supabase-js';

const fallbackSupabaseUrl = 'https://ouxowocfumofekeeqcne.supabase.co';
const fallbackPublishableKey = 'sb_publishable_VFDW3S3sx6trT1-StDmalw_AEgD_wEO';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || fallbackSupabaseUrl;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || fallbackPublishableKey;

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
